import { render, staticRenderFns } from "./PurchaseOrderListView.vue?vue&type=template&id=65892f64"
import script from "./PurchaseOrderListView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65892f64')) {
      api.createRecord('65892f64', component.options)
    } else {
      api.reload('65892f64', component.options)
    }
    module.hot.accept("./PurchaseOrderListView.vue?vue&type=template&id=65892f64", function () {
      api.rerender('65892f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderListView.vue"
export default component.exports